"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kahbaRuntimeOutputFullDataItemKey = void 0;
const constants_iso_1 = require("@wranggle/constants-iso");
const reserved_key_util_1 = require("../utils/reserved-key-util");
/**
 * Redis item/key for storing the final output of a successful, non-erroring automation. Stored in a single redis key, as json string.
 *
 * Not all automations are configured to save their output, and most will have a short expiration set. See runnerOpts.
 * Written to redis by task-runner, in an aux task.
 *
 * todo: blocker: require authorEnv and use it as prefix in all redis keys. (eg, "dev", "prod", etc)
 */
function kahbaRuntimeOutputFullDataItemKey(kahbaRuntimeUid) {
    return `${reserved_key_util_1.getReservedPrefix(constants_iso_1.ReservedKeyType.KahbaRuntimeOutputFullDataItem)}:kahbaRuntime:${kahbaRuntimeUid}`;
}
exports.kahbaRuntimeOutputFullDataItemKey = kahbaRuntimeOutputFullDataItemKey;
//# sourceMappingURL=kahba-runtime-data-output.js.map